// extracted by mini-css-extract-plugin
export default {"root":"xQEKA_","content":"i2yDiH"};